export type DataConnectionCategory = 'warehouse' | 'catalog' | 'apps' | 'documents';

export type DataConnectionCategoryFilter = 'all' | DataConnectionCategory;

const WAREHOUSE_TYPES = new Set(['bigquery', 'snowflake', 'postgres', 'redshift', 'erp', 'mariadb']);
const REGISTRY_WAREHOUSE_TYPES = new Set(['bigquery', 'snowflake', 'postgres', 'erp', 'mariadb']);
const CATALOG_TYPES = new Set(['atlan']);
const APP_TYPES = new Set(['hubspot', 'fathom', 'granola', 'people_data_labs', 'greenhouse']);
const DOCUMENT_TYPES = new Set(['s3', 'filesystem']);

export function getDataConnectionCategory(connectorType: string): DataConnectionCategory {
  const t = connectorType.toLowerCase();
  if (WAREHOUSE_TYPES.has(t)) return 'warehouse';
  if (CATALOG_TYPES.has(t)) return 'catalog';
  if (APP_TYPES.has(t)) return 'apps';
  if (DOCUMENT_TYPES.has(t)) return 'documents';
  return 'apps';
}

export function supportsWarehouseRegistry(connectorType: string): boolean {
  return REGISTRY_WAREHOUSE_TYPES.has(connectorType.toLowerCase());
}

export function getDataConnectionCategoryLabel(category: DataConnectionCategory): string {
  switch (category) {
    case 'warehouse':
      return 'Warehouse Connections';
    case 'catalog':
      return 'Catalog Connections';
    case 'documents':
      return 'Documents';
    default:
      return 'Apps';
  }
}
